import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import * as React from 'react';
import { PaymentTypeEnum } from '../../../../common/enums.js';
import { debitOrCreditCardMsg, invoiceMsg, t } from '../../../../common/i18n';
import type { PaymentType } from '../../../../common/enums.js';

import './SelectPaymentMethod.scss';

const OptionId = {
  BILLING_ACCOUNT: 'billing-account-payment',
  CARD: 'card-payment',
} as const;

type PaymentOptionConfig = {
  id: string;
  name: string;
  description?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
};

const paymentOptions: PaymentOptionConfig[] = [
  {
    id: OptionId.BILLING_ACCOUNT,
    name: t.JF65(invoiceMsg),
    description: t.GRAL('Email invoice, E-invoice or Paper invoice'),
    icon: <CL.Icon icon="invoice" size="l" />,
  },
  {
    id: OptionId.CARD,
    name: t.UKMC(debitOrCreditCardMsg),
    description: 'Visa, Mastercard',
    icon: <CL.Icon icon="money" size="l" />,
  },
];

const optionIdToPaymentType: Record<string, PaymentType> = {
  [OptionId.BILLING_ACCOUNT]: PaymentTypeEnum.BILLING_ACCOUNT,
  [OptionId.CARD]: PaymentTypeEnum.CARD,
};

export interface SelectPaymentMethodCoCoProps {
  paymentType: PaymentType;
  onChange: (paymentType: PaymentType) => void;
  label?: string;
  className?: string;
  isCardPaymentPossible?: boolean;
}

export const SelectPaymentMethodCoCo = ({
  paymentType,
  onChange,
  label = t.CBBN('Choose payment method'),
  className,
  isCardPaymentPossible,
}: SelectPaymentMethodCoCoProps) => {
  const value = paymentType === PaymentTypeEnum.BILLING_ACCOUNT ? OptionId.BILLING_ACCOUNT : OptionId.CARD;
  const disabledCard = isCardPaymentPossible === false;

  return (
    <CL.SelectGroup
      label={label}
      className={classNames('of-payment-method-selectgroup', className)}
      products={paymentOptions.map(option => ({
        ...option,
        disabled: option.id === OptionId.CARD ? disabledCard : (option.disabled ?? false),
      }))}
      value={value}
      onChange={(optionId: string) => {
        const mapped = optionIdToPaymentType[optionId];
        if (mapped) {
          onChange(mapped);
        }
      }}
    />
  );
};

export const SelectPaymentMethodCoCoIds = OptionId;
